/**
 * Created by Federico Brocco on 07/05/2022.
 *
 * @format
 */

/**
 * Salva la sessione dopo un login. Se il backend risponde scelta_soggetto=true, session_token
 * e' un token di scelta (vale solo per deleghe/scegli_soggetto) e il soggetto va ancora scelto.
 */
const salvaSessione = function (responseJson) {
    const scelta = responseJson.scelta_soggetto === true;
    sessionStorage.setItem("userData", JSON.stringify(scelta ? {...responseJson.user, scopo: 'scelta'} : responseJson.user));
    localStorage.setItem('hash', responseJson.session_token);
    if (scelta) {
        sessionStorage.setItem('haDeleghe', '1');
    }
};

/**
 * Verifica i permessi dell'utente tramite hash di sessione
 * @param {string|null} hash - Token di sessione da verificare (se null, usa quello salvato in localStorage)
 * @returns {Promise<Object>} Promise che risolve con i dati dei permessi o rigetta in caso di errore
 */
let permission = function (hash) {
    return new Promise(function (resolve, reject) {

        const hashCheck = (hash !== null && hash !== undefined) ? hash : localStorage.getItem('hash');

        if (hashCheck === null || hashCheck === undefined) {
            console.log('No hash provided and no hash in localStorage');
            reject("NO_AUTH");
            return;
        }

        fetch(window.route.permission, {
            headers: {'x-access-token': hashCheck},
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                // window.checkAuth(responseJson.status);
                // permission e' un oggetto se il token e' valido, altrimenti una stringa ("Expired", "Invalid", ...)
                if (responseJson.permission && typeof responseJson.permission === "object") {
                   
                    sessionStorage.setItem("userData", JSON.stringify(responseJson.permission));
                    localStorage.setItem("hash", hashCheck);
                  
                    resolve(responseJson);
                } else {
                   
                    localStorage.removeItem("hash");
                    sessionStorage.removeItem("userData");
                    reject(responseJson);
                }
            })
            .catch((e) => {
                console.error('Permission request failed:', e);
                localStorage.removeItem("hash");
                sessionStorage.removeItem("userData");
                reject("NO_AUTH")
            });
    });
};

/**
 * Esegue il login con credenziali username/password
 * @param {Object} credential - Oggetto con le credenziali
 * @param {string} credential.fiscal_code - Codice fiscale o username dell'utente
 * @param {string} credential.password - Password dell'utente
 * @returns {Promise<Object>} Promise che risolve con i dati utente o rigetta in caso di errore
 */
let login = function (credential) {
    return new Promise(function (resolve, reject) {
        fetch(window.route.login, {
            method: 'POST',
            headers: {'Content-Type': 'application/json', "access-control-allow-origin": "*"},
            body: JSON.stringify({
                fiscal_code : credential.fiscal_code,
                password : credential.password
            })
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (typeof responseJson.session_token !== 'undefined' && responseJson.session_token !== null) {
                   
                    salvaSessione(responseJson);
                    
                    resolve(responseJson.user);
                } else {
                   
                    localStorage.removeItem('hash');
                    sessionStorage.removeItem("userData");
                    reject({
                        error: "INVALID_SESSION_TOKEN",
                        message: "Il server non ha fornito un token di sessione valido",
                        originalResponse: responseJson
                    });
                }
            }).catch((e) => {
                console.error(e.message);
                reject(e);
            });
    });
};

/**
 * Esegue il login tramite SPID
 * @returns {Promise<Object>} Promise che risolve con i dati utente e session token o rigetta in caso di errore
 */
let loginSPID = function () {
    return new Promise(function (resolve, reject) {
        let app_aggregator_url = 'https://utd-' + window.getMunicipalityString().replace('_','-') + '.megtributi.it';
        // console.log(app_aggregator_url);
        fetch(app_aggregator_url + "/utd/backoffice/v1/login_spid/", {
            method: 'GET',
            headers: {'Content-Type': 'application/json'}
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log('API login spid', responseJson);
                if (typeof responseJson.session_token !== 'undefined') {
                    salvaSessione(responseJson);
                    // resolve(responseJson.user);
                    //new
                    resolve(responseJson);
                } else {
                    localStorage.removeItem('hash');
                    sessionStorage.removeItem("userData");
                    reject(responseJson);
                }
            }).catch((e) => {
            console.error(e.message);
            reject(e);
        });
    });
};

/**
 * Login con CIE, CNS o SPID OIDC: il Relying Party su GovAuth riporta il cittadino
 * con ?cie_code=..., il backoffice lo riscatta presso il RP (v1/login_cie)
 * @param {string} code - codice monouso ricevuto dal RP (vale 60 secondi)
 * @returns {Promise<Object>} Promise che risolve con {user, session_token}
 */
let loginCIE = function (code) {
    return new Promise(function (resolve, reject) {
        fetch(window.route.loginCIE, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({cie_code: code})
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (typeof responseJson.session_token !== 'undefined' && responseJson.session_token !== null) {
                    salvaSessione(responseJson);
                    resolve(responseJson);
                } else {
                    localStorage.removeItem('hash');
                    sessionStorage.removeItem("userData");
                    reject(responseJson);
                }
            }).catch((e) => {
            console.error(e.message);
            reject(e);
        });
    });
};

/**
 * Elenco dei soggetti per cui chi e' loggato puo' operare (deleghe valide).
 * Accetta sia il token di scelta sia il token operativo.
 * @returns {Promise<Object>} {deleghe: [{id, delegante, fiscal_code, data_fine}], attuale, delegato}
 */
let deleghe = function () {
    return new Promise(function (resolve, reject) {
        fetch(window.route.deleghe, {
            method: 'GET',
            headers: {'x-access-token': localStorage.getItem('hash')}
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (Array.isArray(responseJson.deleghe)) {
                    if (responseJson.deleghe.length > 0) {
                        sessionStorage.setItem('haDeleghe', '1');
                    }
                    resolve(responseJson);
                } else {
                    reject(responseJson);
                }
            }).catch((e) => {
                console.error(e.message);
                reject(e);
            });
    });
};

/**
 * Sceglie per chi operare e sostituisce il token con quello operativo.
 * Puo' essere richiamata per cambiare delegante: ogni scelta e' registrata dal backend.
 * @param {Object} scelta - {personale: true} oppure {delega_id: "..."}
 * @returns {Promise<Object>} {user, session_token}
 */
let scegliSoggetto = function (scelta) {
    return new Promise(function (resolve, reject) {
        fetch(window.route.scegliSoggetto, {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'x-access-token': localStorage.getItem('hash')},
            body: JSON.stringify(scelta)
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (typeof responseJson.session_token === 'string' && responseJson.session_token !== '') {
                    sessionStorage.setItem("userData", JSON.stringify(responseJson.user));
                    localStorage.setItem('hash', responseJson.session_token);
                    resolve(responseJson);
                } else {
                    reject(responseJson);
                }
            }).catch((e) => {
                console.error(e.message);
                reject(e);
            });
    });
};

const AuthAPI = {
    permission: permission,
    login: login,
    loginSPID: loginSPID,
    loginCIE: loginCIE,
    deleghe: deleghe,
    scegliSoggetto: scegliSoggetto
};

export default AuthAPI;
